import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class KeyboardService {
  private readonly isMobileApp = environment.mobileApp?.isMobileApp ?? false;
  private readonly isAndroid = Capacitor.getPlatform() === 'android';

  registerKeyboardListeners(): void {
    if (!this.isMobileApp || !this.isAndroid) return;

    Keyboard.addListener('keyboardWillShow', (info) => {
      this.addKeyboardSpace(info);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      this.removeKeyboardSpace();
    });
  }

  // On ANDROID keyboard covers elements
  addKeyboardSpace(info): void {
    const elementOfContent = document.querySelector('.shared-modal-body') || document.querySelector('.app-content-area');
    // deduct the android safe area bottom 1.5rem
    const bottomPadding = info.keyboardHeight - 24;
    (elementOfContent as HTMLElement).style.paddingBottom = `${bottomPadding}px`;
  }

  removeKeyboardSpace(): void {
    const elementOfContent = document.querySelector('.shared-modal-body') || document.querySelector('.app-content-area');
    (elementOfContent as HTMLElement).style.paddingBottom = `0px`;
  }
}
